if (!customElements.get('asap-product-row')) {
  customElements.define('asap-product-row', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('[data-content]');
      this.previous = this.querySelector('[data-row-previous]');
      this.next = this.querySelector('[data-row-next]');
      this.status = this.querySelector('[data-row-status]');
      if (!this.track || !this.previous || !this.next) return;
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => {
        this.update();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => { this.destination = null; }, 150);
      }, { passive: true, signal });
      this.mobile.addEventListener('change', () => { this.destination = null; this.update(); }, { signal });
      window.addEventListener('resize', () => { this.destination = null; this.update(); }, { passive: true, signal });
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      }
      this.dataset.carouselReady = 'true';
      this.update();
    }

    step() {
      const card = this.track.querySelector('[data-product-item]');
      return card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0) : 0;
    }

    move(direction) {
      const step = this.step();
      if (!this.mobile.matches || !step) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const current = this.destination ?? this.track.scrollLeft;
      this.destination = Math.max(0, Math.min(max, (Math.round(current / step) + direction) * step));
      this.track.scrollTo({
        left: this.destination,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const enabled = this.mobile.matches && max > 2;
      this.previous.hidden = !enabled;
      this.next.hidden = !enabled;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      if (this.status) {
        const step = this.step();
        const count = this.track.querySelectorAll('[data-product-item]').length;
        const first = step ? Math.round(this.track.scrollLeft / step) + 1 : 1;
        const last = Math.min(count, first + 1);
        const text = enabled ? `Products ${first}–${last} of ${count}` : '';
        if (this.status.textContent !== text) this.status.textContent = text;
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.settleTimer);
      this.destination = null;
    }
  });
}
